import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

/** Merknaam in de browsertab; ook de titel in index.html vóór de app opstart. */
export const APP_TITLE = 'Mechanics in Motion';
const TITLE_SEPARATOR = ' · ';

/**
 * Enige plek die de titel van de browsertab zet: "<specifiek> · Mechanics in Motion".
 * Het specifieke deel staat vooraan omdat een smalle tab rechts afkapt; zo blijven
 * tabs van elkaar te onderscheiden. Zet nergens anders `document.title`.
 *
 * - De pagina komt na elke navigatie uit PageTitleStrategy (route-title of UPAM-menunaam).
 * - Een detail, bv. de naam van de actieve chart, wint van de pagina. Wie een detail zet,
 *   wist het ook weer (bij het verlaten van de pagina), anders blijft het hangen.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly title = inject(Title);
  private page: string | undefined;
  private detail: string | undefined;

  setPage(name: string | undefined): void {
    this.page = name;
    this.apply();
  }

  setDetail(text: string | undefined): void {
    this.detail = text;
    this.apply();
  }

  private apply(): void {
    const specific = (this.detail?.trim() || this.page?.trim()) ?? '';
    this.title.setTitle(specific && specific !== APP_TITLE ? `${specific}${TITLE_SEPARATOR}${APP_TITLE}` : APP_TITLE);
  }
}
